export const LOGIN = {
  emailInput: 'login-email-input',
  passwordInput: 'login-password-input',
  roleSelect: 'login-role-select',
  rememberMe: 'login-remember-checkbox',
  submitButton: 'login-submit-button',
  errorMessage: 'login-error-message',
};

export const REGISTER = {
  nameInput: 'register-name-input',
  emailInput: 'register-email-input',
  passwordInput: 'register-password-input',
  passwordConfirmInput: 'register-password-confirm-input',
  submitButton: 'register-submit-button',
  loginLink: 'register-login-link',
};

export const LOGOUT = {
  button: 'logout-button',
};
